<template>
    <div class="relative inline-block text-left">
        <div
            class="cursor-pointer rounded bg-slate-50 p-2 text-slate-500 transition hover:bg-slate-100 hover:text-slate-900"
            :aria-expanded="dropdownOpen"
            aria-label="Perform action"
            aria-haspopup="true"
            @click.stop="toggleDropdown"
        >
            <div class="flex items-center justify-center">
                <AppIcon name="chevron-down" class="h-3 w-3" />
            </div>
        </div>

        <div
            v-if="dropdownOpen"
            class="absolute right-0 z-10 mt-1 w-48 origin-top-right rounded border border-slate-200 bg-white py-1.5 shadow-lg"
            role="menu"
        >
            <div class="py-1 text-sm font-medium text-slate-600" role="none">
                <template v-for="(item, index) in menuItems" :key="index">
                    <div v-if="item.divider" class="my-1 border-t border-slate-100"></div>

                    <button
                        v-else
                        type="button"
                        class="flex w-full items-center px-3 py-1.5 hover:bg-slate-50"
                        :class="{ 'text-rose-600 hover:bg-rose-50': item.danger }"
                        role="menuitem"
                        @click.prevent="handleMenuAction(item.action)"
                    >
                        <AppIcon :name="item.icon" class="mr-3 h-3 w-3" />
                        {{ item.label }}
                    </button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConversationActions',

    props: {
        conversation: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            dropdownOpen: false,
        }
    },

    computed: {
        menuItems() {
            const base = [
                { label: 'View Message', icon: 'envelope-open', action: 'viewConversation' },
                { label: 'Reply', icon: 'reply', action: 'replyToConversation' },
                { label: 'Mark as Read', icon: 'envelope-open-text', action: 'markAsRead' },
            ]

            const archiveAction =
                this.conversation.status === 'archived'
                    ? { label: 'Unarchive', icon: 'box-open', action: 'unarchiveConversation' }
                    : { label: 'Archive', icon: 'archive', action: 'archiveConversation' }

            return [
                ...base,
                archiveAction,
                { divider: true },
                { label: 'Delete', icon: 'trash', action: 'deleteConversation', danger: true },
            ]
        },
    },

    mounted() {
        document.addEventListener('click', this.handleClickOutside)
    },

    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside)
    },

    methods: {
        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen
        },

        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.dropdownOpen = false
            }
        },

        handleMenuAction(action) {
            this.dropdownOpen = false
            if (typeof this[action] === 'function') {
                this[action]()
            }
        },

        viewConversation() {
            this.$store.commit('modal:setData', {
                modal_id: 'conversation_view',
                data: {
                    is_open: true,
                    conversation: this.conversation,
                },
            })
        },

        replyToConversation() {
            this.$store.commit('modal:setData', {
                modal_id: 'email_compose',
                data: {
                    is_open: true,
                    replyToConversation: this.conversation,
                    recipient: this.conversation.creator_email,
                    subject: this.conversation.subject.startsWith('Re:')
                        ? this.conversation.subject
                        : `Re: ${this.conversation.subject}`,
                },
            })
        },

        markAsRead() {
            this.$emit('mark-read', this.conversation)
        },

        archiveConversation() {
            this.$emit('archive', this.conversation)
        },

        unarchiveConversation() {
            this.$emit('unarchive', this.conversation)
        },

        deleteConversation() {
            this.$emit('delete', this.conversation)
        },
    },
}
</script>
